import * as React from "react";
import { SVGProps } from "react";

const FolderSvg = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={130}
		height={130}
		viewBox="0 0 130 130"
		fill="none"
		{...props}
	>
		<path
			d="M110.705 27.7607H52.1373C51.8184 27.7607 51.506 27.8507 51.236 28.0205C50.966 28.1903 50.7494 28.4329 50.6113 28.7204C50.4732 29.0078 50.4191 29.3285 50.4552 29.6453C50.4914 29.9622 50.6163 30.2624 50.8157 30.5114L58.2636 39.8213C59.0539 40.8137 60.0583 41.6146 61.2017 42.1642C62.3451 42.7138 63.5979 42.9978 64.8665 42.9951H117.476C117.925 42.9951 118.355 42.8168 118.673 42.4993C118.99 42.1819 119.169 41.7513 119.169 41.3024V36.2243C119.166 33.9804 118.273 31.8292 116.687 30.2426C115.1 28.6559 112.949 27.7634 110.705 27.7607Z"
			fill="#FFB125"
		/>
		<path
			d="M119.166 39.6097H64.8643C64.104 39.6097 63.3535 39.4387 62.6684 39.1094C61.9832 38.7801 61.3808 38.3009 60.9059 37.7073L52.4398 27.1243C51.3328 25.7361 49.9268 24.6158 48.3266 23.8467C46.7263 23.0776 44.9731 22.6797 43.1976 22.6826H19.2965C17.0519 22.6826 14.8991 23.5743 13.3119 25.1615C11.7247 26.7488 10.833 28.9015 10.833 31.1462L10.833 98.8545C10.833 101.099 11.7247 103.252 13.3119 104.839C14.8991 106.426 17.0519 107.318 19.2965 107.318H110.703C112.947 107.318 115.1 106.426 116.687 104.839C118.275 103.252 119.166 101.099 119.166 98.8545V39.6097Z"
			fill="#FCD354"
		/>
		<path
			d="M59.8145 62.6031C59.8145 59.5706 62.2728 57.1123 65.3052 57.1123C68.3377 57.1123 70.796 59.5706 70.796 62.6031V65.9473H59.8145V62.6031Z"
			fill="white"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M70.2526 71.2888V62.4457C70.2526 59.64 67.9728 57.3656 65.1605 57.3656C62.3483 57.3656 60.0684 59.64 60.0684 62.4457V71.2888C60.0684 74.0945 62.3483 76.3689 65.1605 76.3689C67.9728 76.3689 70.2526 74.0945 70.2526 71.2888ZM65.1605 54.167C60.5776 54.167 56.8623 57.8735 56.8623 62.4457V71.2888C56.8623 75.861 60.5776 79.5675 65.1605 79.5675C69.7435 79.5675 73.4588 75.861 73.4588 71.2888V62.4457C73.4588 57.8735 69.7435 54.167 65.1605 54.167Z"
			fill="white"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M78.4044 67.4199C79.3402 67.4199 80.0989 68.1728 80.0989 69.1016V74.1465C80.0989 75.6304 79.5929 77.1718 78.8428 78.6512C78.0842 80.1471 77.0207 81.6874 75.7735 83.1995C73.2794 86.2234 69.9452 89.2612 66.5083 91.7592C65.9933 92.1335 65.31 92.1889 64.7406 91.9023C64.1713 91.6158 63.8125 91.036 63.8125 90.4025V87.1455C54.9332 86.2929 48.75 78.7787 48.75 69.849C48.75 68.9202 49.5087 68.1673 50.4445 68.1673C51.3804 68.1673 52.1391 68.9202 52.1391 69.849C52.1391 77.6982 57.815 83.8627 65.5071 83.8627C66.4429 83.8627 67.2016 84.6156 67.2016 85.5444V86.9488C69.441 85.0882 71.5104 83.0582 73.151 81.0692C74.2925 79.6852 75.2001 78.3527 75.8154 77.1393C76.4391 75.9093 76.7098 74.9049 76.7098 74.1465V69.1016C76.7098 68.1728 77.4685 67.4199 78.4044 67.4199Z"
			fill="white"
		/>
	</svg>
);

export default FolderSvg;
